/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recycle_Pumps_EcsInputs */



/**
* | output |
* | --- |
* | "ECS recirculation pump" |
*
* @param {Recycle_Pumps_EcsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const recycle_pumps_ecs = /** @type {((inputs?: Recycle_Pumps_EcsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recycle_Pumps_EcsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("ECS recirculation pump")
	return /** @type {LocalizedString} */ ("Pompe de bouclage ECS")
});